import { render } from "./AdminForm.vue?vue&type=template&id=dbd7dc1a&scoped=true"
import script from "./AdminForm.vue?vue&type=script&lang=js"
export * from "./AdminForm.vue?vue&type=script&lang=js"

import "./AdminForm.vue?vue&type=style&index=0&id=dbd7dc1a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd7dc1a"]])

export default __exports__